/* ==========================================================================
   E. Michael — outfit builder
   --------------------------------------------------------------------------
   Colour and size selection across colourways that are stored as separate
   Shopify products. Used by the homepage sets, the homepage product cards,
   the cart "Pairs well with" row and the product page (colourway
   swatches and "Wear it with").

   Data: snippets/em-catalog.liquid renders every product in
   collections/the-collection as JSON (#EMCatalog). Colourways are grouped
   by product type. Colour names come from the product title.
   No dependencies. Safe to remove with the em-* snippets.
   ========================================================================== */
(function () {
  'use strict';
  if (window.EMShop) return;

  var COLOUR_ORDER = ['highlands', 'midnight', 'summit', 'sandstone'];
  var SWATCH = {
    highlands: '#33473a',
    midnight: '#151515',
    summit: '#fbfaf7',
    sandstone: '#e2d8c6'
  };
  var TYPE_SUFFIX = /\s+(polo|shorts?|jogger|italian leather belt|leather belt|belt|snapback|cap)$/i;

  /* --------------------------------------------------------------- data */

  var catalog = [];
  var byHandle = {};
  var families = {};

  function loadCatalog() {
    var el = document.getElementById('EMCatalog');
    if (!el) return;
    try { catalog = JSON.parse(el.textContent) || []; } catch (e) { catalog = []; }
    catalog.forEach(function (p) {
      p.colour = colourName(p.t);
      p.avail = p.v.some(function (v) { return v[2]; });
      byHandle[p.h] = p;
      (families[p.ty] = families[p.ty] || []).push(p);
    });
    Object.keys(families).forEach(function (type) {
      families[type].sort(function (a, b) { return colourRank(a.colour) - colourRank(b.colour); });
    });
  }

  function colourName(title) {
    var raw = String(title || '').replace(TYPE_SUFFIX, '').trim().toLowerCase();
    return raw.replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
  }

  function colourRank(name) {
    var first = name.split('/')[0].trim().toLowerCase();
    var i = COLOUR_ORDER.indexOf(first);
    var twoTone = name.indexOf('/') > -1 ? 10 : 0;
    return (i === -1 ? 9 : i) + twoTone;
  }

  function swatchStyle(name) {
    var parts = name.toLowerCase().split('/').map(function (s) { return SWATCH[s.trim()] || '#cfcac2'; });
    if (parts.length > 1) return 'background:linear-gradient(135deg,' + parts[0] + ' 50%,' + parts[1] + ' 50%)';
    return 'background:' + parts[0];
  }

  function sizeLabel(raw) {
    // Belts read "100 cm | 30–32 | 85"; the first part is the clear label.
    return String(raw || '').split('|')[0].trim();
  }

  function img(url, width) {
    if (!url) return '';
    return url.replace(/([?&])width=\d+/, '$1width=' + width);
  }

  function money(cents) {
    var fmt = (window.MinimogSettings && window.MinimogSettings.money_format) || '${{amount}}';
    var value = (Math.round(Number(cents) || 0) / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = /amount_no_decimals/.test(fmt);
    var out = noDecimals ? whole : whole + '.' + parts[1];
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '');
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* --------------------------------------------------------------- cart */

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addItems(items) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || 'Could not add to cart');
          throw err;
        }
        return data;
      });
    });
  }

  function refreshCart(openDrawer) {
    var drawer = document.querySelector('m-cart-drawer');
    var cartPage = document.querySelector('m-cart');
    if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
      drawer.onCartDrawerUpdate();
      if (openDrawer) drawer.open();
    } else if (cartPage && typeof cartPage.onCartUpdate === 'function') {
      cartPage.onCartUpdate();
    } else if (openDrawer) {
      window.location.href = root() + 'cart';
      return;
    }
    // Keeps the header count and any other cart listeners in step.
    try {
      window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source: 'em-shop' });
    } catch (e) {}
  }

  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  }

  /* ------------------------------------------------------------- picker */
  /*
    <em-picker data-handle="…" data-mode="select|display">
    select  — colour swatches and size buttons; a variant must be chosen
    display — colour swatches and a read-only size row (homepage cards)
    link    — colour swatches that open each colourway (product page)
    Updates [data-em-img] [data-em-name] [data-em-price] [data-em-link]
    inside the closest [data-em-scope], then fires a bubbling em:change.
  */
  class EMPicker extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.mode = this.getAttribute('data-mode') || 'select';
      this.product = byHandle[this.getAttribute('data-handle')];
      if (!this.product) return; // keep server-rendered fallback
      this.family = families[this.product.ty] || [this.product];
      if (!this.product.avail) {
        var firstOpen = this.family.filter(function (p) { return p.avail; })[0];
        if (firstOpen && this.mode === 'select') this.product = firstOpen;
      }
      this.variantId = null;
      this.uid = 'emp' + Math.random().toString(36).slice(2, 8);
      this.autoSelectOneSize();
      this.render(false);
    }

    hasSizes(p) {
      return p.v.length > 1 || (p.v[0] && p.v[0][1] !== '');
    }

    autoSelectOneSize() {
      var p = this.product;
      if (this.mode === 'select' && !this.hasSizes(p) && p.v[0] && p.v[0][2]) this.variantId = p.v[0][0];
    }

    get selected() {
      var p = this.product;
      var id = this.variantId;
      var v = p.v.filter(function (x) { return x[0] === id; })[0];
      return {
        handle: p.h,
        title: p.t,
        variantId: v ? v[0] : null,
        available: !!(v && v[2]),
        price: v ? v[3] : p.p,
        size: v ? sizeLabel(v[1]) : ''
      };
    }

    setColour(handle) {
      var next = byHandle[handle];
      if (!next || next === this.product) return;
      var prevSize = this.selected.size;
      this.product = next;
      this.variantId = null;
      if (prevSize) {
        var match = next.v.filter(function (v) { return sizeLabel(v[1]) === prevSize && v[2]; })[0];
        if (match) this.variantId = match[0];
      }
      this.autoSelectOneSize();
      this.render(true);
    }

    setSize(id) {
      this.variantId = id;
      this.render(true);
    }

    updateScope() {
      var scope = this.closest('[data-em-scope]');
      if (!scope) return;
      var p = this.product;
      var image = scope.querySelector('[data-em-img]');
      if (image && p.im) {
        var w = parseInt(image.getAttribute('data-em-img'), 10) || 400;
        image.src = img(p.im, w);
        image.srcset = img(p.im, w) + ' 1x, ' + img(p.im, w * 2) + ' 2x';
        image.removeAttribute('sizes');
        image.alt = p.t;
      }
      scope.querySelectorAll('[data-em-name]').forEach(function (n) { n.textContent = p.t; });
      scope.querySelectorAll('[data-em-price]').forEach(function (n) { n.textContent = money(p.p); });
      scope.querySelectorAll('[data-em-link]').forEach(function (n) { n.setAttribute('href', p.u); });
      scope.classList.toggle('vault-card--soldout', !p.avail && this.mode === 'display');
    }

    render(changed) {
      var self = this;
      var p = this.product;
      var html = '';

      // link — product page: colourway swatches that open the other colour.
      if (this.mode === 'link') {
        if (this.family.length < 2) { this.innerHTML = ''; return; }
        html += '<p class="em-cw__label">Colour: <span>' + esc(p.colour) + '</span></p>';
        html += '<div class="em-pk__swatches em-cw__list" aria-label="Colour">';
        this.family.forEach(function (f) {
          var on = f === p;
          var label = f.colour + (f.avail ? '' : ' — sold out');
          html += '<a class="em-pk__swatch' + (on ? ' is-on' : '') + (f.avail ? '' : ' is-out') + '"' +
            ' href="' + esc(f.u) + '"' + (on ? ' aria-current="true"' : '') +
            ' aria-label="' + esc(label) + '" title="' + esc(label) + '">' +
            '<span style="' + swatchStyle(f.colour) + '"></span></a>';
        });
        html += '</div>';
        this.innerHTML = html;
        return;
      }

      if (this.family.length > 1) {
        html += '<div class="em-pk__swatches" role="radiogroup" aria-label="Colour">';
        this.family.forEach(function (f) {
          var on = f === p;
          var label = f.colour + (f.avail ? '' : ' — sold out');
          html += '<button type="button" class="em-pk__swatch' + (on ? ' is-on' : '') + (f.avail ? '' : ' is-out') + '"' +
            ' role="radio" aria-checked="' + on + '" aria-label="' + esc(label) + '" title="' + esc(label) + '"' +
            ' data-colour="' + esc(f.h) + '"' + (!f.avail && !on ? ' disabled' : '') + '>' +
            '<span style="' + swatchStyle(f.colour) + '"></span></button>';
        });
        html += '</div>';
      }

      if (this.hasSizes(p)) {
        if (this.mode === 'display') {
          html += '<ul class="em-pk__sizes em-pk__sizes--display" aria-label="Sizes">';
          p.v.forEach(function (v) {
            var label = sizeLabel(v[1]);
            html += '<li class="em-pk__dsize' + (v[2] ? '' : ' is-out') + '"' +
              ' aria-label="' + esc(label + (v[2] ? ' available' : ' sold out')) + '">' + esc(label) + '</li>';
          });
          html += '</ul>';
        } else {
          html += '<div class="em-pk__sizes" role="radiogroup" aria-label="Size">';
          p.v.forEach(function (v) {
            var label = sizeLabel(v[1]);
            var on = v[0] === self.variantId;
            html += '<button type="button" class="em-pk__size' + (on ? ' is-on' : '') + (v[2] ? '' : ' is-out') + '"' +
              ' role="radio" aria-checked="' + on + '"' +
              ' aria-label="' + esc(v[1] + (v[2] ? '' : ', sold out')) + '"' +
              (v[1] !== label ? ' title="' + esc(v[1]) + '"' : '') +
              ' data-variant="' + v[0] + '"' + (v[2] ? '' : ' disabled') + '>' + esc(label) + '</button>';
          });
          html += '</div>';
        }
      } else {
        html += '<p class="em-pk__onesize">' + (p.avail ? 'One size' : 'Sold out') + '</p>';
      }

      this.innerHTML = html;

      // Re-render after the click has finished bubbling. Replacing the
      // buttons mid-event detaches the click target, and the theme's cart
      // drawer reads a detached target as a click outside and closes.
      this.querySelectorAll('[data-colour]').forEach(function (b) {
        b.addEventListener('click', function () {
          var h = b.getAttribute('data-colour');
          setTimeout(function () { self.setColour(h); }, 0);
        });
      });
      this.querySelectorAll('[data-variant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var id = Number(b.getAttribute('data-variant'));
          setTimeout(function () { self.setSize(id); }, 0);
        });
      });
      this.querySelectorAll('[role="radiogroup"]').forEach(function (group) {
        group.addEventListener('keydown', function (e) { self.onArrow(e, group); });
      });

      if (changed) this.updateScope();
      if (!changed && this.product.h !== this.getAttribute('data-handle')) this.updateScope();
      this.dispatchEvent(new CustomEvent('em:change', { bubbles: true, detail: this.selected }));
    }

    onArrow(e, group) {
      if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
      var items = Array.prototype.slice.call(group.querySelectorAll('button:not([disabled])'));
      var i = items.indexOf(document.activeElement);
      if (i === -1) return;
      e.preventDefault();
      var step = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1;
      var next = items[(i + step + items.length) % items.length];
      var self = this;
      var sel = next.hasAttribute('data-colour')
        ? '[data-colour="' + next.getAttribute('data-colour') + '"]'
        : '[data-variant="' + next.getAttribute('data-variant') + '"]';
      next.click();
      setTimeout(function () {
        var again = self.querySelector(sel);
        if (again) again.focus();
      }, 0);
    }
  }

  /* ---------------------------------------------------------- set (home) */

  class EMSet extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.button = this.querySelector('[data-em-addset]');
      this.message = this.querySelector('[data-em-setmsg]');
      this.retail = this.querySelector('[data-vault-retail]');
      this.tierOut = this.querySelector('[data-em-tier]');
      try { this.tiers = JSON.parse(this.getAttribute('data-tiers') || '[]'); } catch (e) { this.tiers = []; }
      this.addEventListener('em:change', function () { self.update(); });
      if (this.button) this.button.addEventListener('click', function (e) { e.preventDefault(); self.add(); });
      // Pickers may have connected first; read their state now.
      setTimeout(function () { self.update(); });
    }

    picks() {
      return Array.prototype.map.call(this.querySelectorAll('em-picker'), function (p) {
        return p.product ? p.selected : null;
      }).filter(Boolean);
    }

    update() {
      var picks = this.picks();
      if (!picks.length) return;
      var total = 0;
      var missing = 0;
      picks.forEach(function (p) {
        total += p.price;
        if (!p.variantId || !p.available) missing += 1;
      });
      if (this.retail) this.retail.textContent = money(total);
      if (this.tierOut) {
        var pct = 0;
        this.tiers.forEach(function (t) { if (!pct && total >= t[0]) pct = t[1]; });
        var below = this.tierOut.getAttribute('data-below') || '';
        this.tierOut.textContent = pct ? 'This set alone reaches the ' + pct + '% tier.' : below;
      }
      this.ready = missing === 0;
      if (this.button && !this.busy) this.button.setAttribute('aria-disabled', this.ready ? 'false' : 'true');
      if (this.message && !this.locked) {
        this.message.textContent = this.ready
          ? this.message.getAttribute('data-default') || ''
          : (missing === 1 ? 'Choose a size for the remaining piece.' : 'Choose a size for each piece.');
      }
    }

    add() {
      var self = this;
      if (!this.ready || this.busy) return;
      var name = this.getAttribute('data-setname') || 'Set';
      var picks = this.picks();
      var items = picks.map(function (p) { return { id: p.variantId, quantity: 1, properties: { Set: name } }; });
      var label = this.button.textContent;
      this.busy = true;
      this.locked = false;
      this.button.textContent = 'Adding…';
      this.button.setAttribute('aria-disabled', 'true');
      addItems(items).then(function () {
        var value = picks.reduce(function (s, p) { return s + p.price; }, 0) / 100;
        track('em_homepage_set_add', {
          set: name,
          variant_ids: picks.map(function (p) { return p.variantId; }),
          products: picks.map(function (p) { return p.title + ' / ' + p.size; }),
          value: value,
          currency: (window.MinimogSettings && window.MinimogSettings.currency_code) || 'AUD'
        });
        self.button.textContent = label;
        self.busy = false;
        self.update();
        refreshCart(true);
      }).catch(function (err) {
        self.button.textContent = label;
        self.busy = false;
        self.locked = true;
        if (self.message) self.message.textContent = err.message || 'That could not be added just now. Please try again.';
        self.update();
        setTimeout(function () { self.locked = false; }, 6000);
      });
    }
  }

  /* -------------------------------------------------------- pair (cart) */

  class EMPair extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.button = this.querySelector('[data-em-addpair]');
      this.picker = this.querySelector('em-picker');
      this.addEventListener('em:change', function () { self.update(); });
      if (this.button) this.button.addEventListener('click', function (e) { e.preventDefault(); self.add(); });
      setTimeout(function () { self.update(); });
    }

    update() {
      if (!this.picker || !this.picker.product || !this.button || this.busy) return;
      var s = this.picker.selected;
      var ok = !!(s.variantId && s.available);
      this.button.setAttribute('aria-disabled', ok ? 'false' : 'true');
      this.button.textContent = ok ? 'Add' : (this.picker.product.avail ? 'Select size' : 'Sold out');
    }

    add() {
      var self = this;
      var s = this.picker && this.picker.selected;
      if (!s || !s.variantId || !s.available || this.busy) return;
      this.busy = true;
      this.button.textContent = 'Adding…';
      this.button.setAttribute('aria-disabled', 'true');
      // Product page cards ("Wear it with") open the drawer and keep the card;
      // cart cards are re-rendered by the cart itself.
      var onPdp = this.hasAttribute('data-open-drawer');
      addItems([{ id: s.variantId, quantity: 1 }]).then(function () {
        track(self.getAttribute('data-track') || 'em_cart_recommendation_add', {
          product: s.title,
          variant_id: s.variantId,
          size: s.size,
          value: s.price / 100,
          currency: (window.MinimogSettings && window.MinimogSettings.currency_code) || 'AUD'
        });
        self.busy = false;
        if (onPdp) {
          self.button.textContent = 'Added';
          setTimeout(function () { self.update(); }, 2000);
        }
        refreshCart(onPdp);
      }).catch(function (err) {
        self.busy = false;
        self.button.textContent = 'Unavailable';
        self.setAttribute('title', err.message || '');
        setTimeout(function () { self.update(); }, 2500);
      });
    }
  }

  /* ---------------------------------------------------- product page */
  /*
    The theme's "no size selected by default" setting clears every option,
    including single-value ones (each colourway is its own product, so
    Colour has one value). Re-select those so choosing a size is enough,
    and hide the one-value Colour row where the swatches replace it.
  */
  function keepSingleOptions() {
    var hasSwatches = !!document.querySelector('em-picker[data-mode="link"]');
    document.querySelectorAll('variant-picker [data-picker-field]').forEach(function (field) {
      var radios = field.querySelectorAll('input[type="radio"]');
      if (radios.length !== 1) return;
      if (!radios[0].checked) {
        radios[0].checked = true;
        field.setAttribute('data-selected-value', radios[0].value);
        var label = field.querySelector('.option-label--selected');
        if (label) label.textContent = radios[0].value;
      }
      if (hasSwatches && /colou?r/i.test(field.getAttribute('data-option-name') || '')) {
        var row = field.closest('.m-product-option') || field;
        row.classList.add('em-hide');
      }
    });
  }

  if (document.querySelector('variant-picker')) {
    customElements.whenDefined('variant-picker').then(function () { setTimeout(keepSingleOptions, 0); });
  }

  loadCatalog();
  window.EMShop = { byHandle: byHandle, families: families, money: money, refreshCart: refreshCart, track: track };
  customElements.define('em-picker', EMPicker);
  customElements.define('em-set', EMSet);
  customElements.define('em-pair', EMPair);
})();
